var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntroBuildingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 45,
    height: 45,
    rx: 4,
    fill: "#07364B",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 16.25V13.75C22.5 12.375 21.375 11.25 20 11.25H12.5C11.125 11.25 10 12.375 10 13.75V31.25C10 32.625 11.125 33.75 12.5 33.75H32.5C33.875 33.75 35 32.625 35 31.25V18.75C35 17.375 33.875 16.25 32.5 16.25H22.5ZM15 31.25H12.5V28.75H15V31.25ZM15 26.25H12.5V23.75H15V26.25ZM15 21.25H12.5V18.75H15V21.25ZM15 16.25H12.5V13.75H15V16.25ZM20 31.25H17.5V28.75H20V31.25ZM20 26.25H17.5V23.75H20V26.25ZM20 21.25H17.5V18.75H20V21.25ZM20 16.25H17.5V13.75H20V16.25ZM31.25 31.25H22.5V28.75H25V26.25H22.5V23.75H25V21.25H22.5V18.75H31.25C31.9375 18.75 32.5 19.3125 32.5 20V30C32.5 30.6875 31.9375 31.25 31.25 31.25ZM30 21.25H27.5V23.75H30V21.25ZM30 26.25H27.5V28.75H30V26.25Z",
    fill: "#07364B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroBuildingsIcon);
export default __webpack_public_path__ + "static/media/intro_buildings_icon.e2ae6e1c0412b8fd3837468364d671d9.svg";
export { ForwardRef as ReactComponent };